define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/heading/NodeImage",
	"csi/html",
	"csi/xml",
	"Specification"
], function(declare,lang,csi,_,NodeImage,html,xml,Specification) {

	var	_getLanguages = function(/*Context*/ctx) {
		// summary: get list of languages for translation
		var	a = ctx._bomLanguages;
		if (!a) {
			var	languages = ctx.getParent().BOMLanguages;
			var	nodes = languages && ctx.cache.getNodes(languages);
			if (nodes) {
				a = _.pluck(csi.sort(nodes, "SortOrder"), "SysID");
				a.splice(0, 0, null);
			} else {
				a = [null];
			}

			ctx._bomLanguages = a;
		}

		return a;
	};

	return declare(NodeImage, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: if no image, then render name of care symbol; make sure image is rendered as thumbnail
			if (!this.inherited(arguments)) {
				// if BOM has multiple languages, then need to output translations as well
				var div = html.create("div", { "class": "csi-attrImage-text" }, refNode);
				_.each(_getLanguages(ctx), function(l) {
					html.create("div", {
						"class": l ? "csi-text" : "csi-image-care-label-header",
						innerText: Specification.getTranslation(ctx.getNode(), l)
					}, div)
				});
			}

			return true;
		}
	});
});